import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {SatDatepickerRangeValue} from 'saturn-datepicker';
import {CommunicationProxyService} from '../../shared/services/communication-proxy.service';
import {CommunicationSubjectEnum} from '../../shared/enum/communication-subject-enum';
import moment from 'moment';
import {MatInput} from '@angular/material/input';
import {subDays} from 'date-fns';

export interface ManagerFiltersControls extends SatDatepickerRangeValue<any> {
  type: ManagerFilterType;
}

export enum ManagerFilterType {
  Today,
  FifteenDays,
  ThirtyDays,
  Range
}

@Component({
  selector: 'app-manager-filters',
  templateUrl: './manager-filters.component.html',
  styleUrls: ['./manager-filters.component.scss']
})
export class ManagerFiltersComponent implements OnInit, AfterViewInit {

  constructor(private communicationProxyService: CommunicationProxyService) {
  }

  filtersControls: ManagerFiltersControls;
  today: Date = new Date();
  minRangeDate: Date = subDays(this.today, 90);

  @ViewChild(MatInput) picker: MatInput;

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.applyFilter({begin: null, end: null, type: 0});
  }

  applyFilter(filtersControls: ManagerFiltersControls) {
    if ((filtersControls.type !== ManagerFilterType.Range) && this.picker) {
      this.picker.value = null;
    }
    this.sendFiltersUpdatedMessage(filtersControls);
  }

  sendFiltersUpdatedMessage(filtersControls: ManagerFiltersControls) {
    this.formatteDateFilter(filtersControls);
    this.communicationProxyService.publishMessage(CommunicationSubjectEnum.onManagerFiltersUpdated, filtersControls);
  }

  formatteDateFilter(filtersControls: ManagerFiltersControls) {
    let startdate: any = moment();
    switch (filtersControls.type) {
      case 0:
        filtersControls.begin = moment(new Date().setHours(0, 0, 0, 0)).format('YYYY-MM-DD[T]00:00:00.000[Z]');
        filtersControls.end = null;
        break;

      case 1:
        startdate = startdate.subtract(15, 'days');
        filtersControls.begin = moment(new Date(startdate).setHours(0, 0, 0, 0)).format('YYYY-MM-DD[T]00:00:00.000[Z]');
        filtersControls.end = moment(new Date().setHours(0, 0, 0, 0)).format('YYYY-MM-DD[T]23:59:59.999[Z]');
        break;

      case 2:
        startdate = startdate.subtract(30, 'days');
        filtersControls.begin = moment(new Date(startdate).setHours(0, 0, 0, 0)).format('YYYY-MM-DD[T]00:00:00.000[Z]');
        filtersControls.end = moment(new Date().setHours(0, 0, 0, 0)).format('YYYY-MM-DD[T]23:59:59.999[Z]');
        break;

      case 3:
        filtersControls.begin = moment(new Date(filtersControls.begin).setHours(0, 0, 0, 0)).format('YYYY-MM-DD[T]00:00:00.000[Z]');
        filtersControls.end = moment(new Date(filtersControls.end).setHours(0, 0, 0, 0)).format('YYYY-MM-DD[T]23:59:59.999[Z]');
        break;
    }
  }
}
